
export default function brandLinks() {
    var wrapper = $('.brand-links ul');

    if (!wrapper.length) {
        return;
    }

    $('<li><a href="#">' + $('h1').text().split(' ')[0] + '</a></li>').appendTo(wrapper);

    $('.brand-link').each(function(i, brand) {
        $('<li><a href="#' + brand.id + '">' + $(brand).html() + '</a></li>').appendTo(wrapper);
    });

    var fixed = wrapper.parent().clone().addClass('fixed hidden').appendTo(wrapper.parent());

    $(window).on('scroll', function() {
        fixed.toggleClass('hidden', wrapper.offset().top > $(document).scrollTop());
    });

    $(wrapper).add(fixed).on('click', 'a', function(e) {
        e.preventDefault();
        var target = $(e.currentTarget).attr('href');

        if (target == '#') {
            target = 'body';
        }

        $(document).scrollTop($(target).offset().top - 100);
    });
};
